<template>
<!-- 暂时只支持第三方使用 -->
 <div>
     <el-upload
     action='aaa'
        :show-file-list="true"
        :file-list="playUrls"
        :http-request="uploadSectionFile"
        :on-remove="onRemove"> <!--此处使用自定义上传实现http-request-->
        <el-button size="small" type="primary">点击上传</el-button>
        <!-- <div slot="tip" class="el-upload__tip">请等待进度条100%之后再提交表单</div> -->
    </el-upload>
    <!-- <el-progress v-show="showProgress" :text-inside="true" :stroke-width="18"
                 :percentage="uploadPercent"></el-progress> -->
 </div>
</template>

<script>
import { ossUploadBigFileNotLab } from '@/utils/action'
export default {
  props: {
    value: {
      type: [Array],
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      playUrls: [],
      showSectionFileName: true,
      sectionFileName: '',
      showProgress: true,
      uploadPercent: 0,
      resourceConfig: 'organization',
      currentValue: [],
      isUpload: null
    }
  },
  watch: {
    value (val) {
      console.log('val--------------', val)
      if (val) {
        this.getImageList(val)
        this.currentValue = val
      }
    },
    playUrls (val) {
      console.log('val-----------list', val)
    },
    isUpload (val) {
      this.$emit('getStatus', val)
    }
  },
  methods: {
    async uploadSectionFile (params) {
      console.log('params', params)
      this.isUpload = true
      let url = await this.$upload(this.resourceConfig, params.file, 'file', ossUploadBigFileNotLab)
      if (url) {
        this.isUpload = false
        let data = {
          url,
          name: params.file.name
        }
        this.currentValue.push(data)
        this.playUrls.push(this.getImageUrl(data))
        this.$emit('input', this.currentValue)
      }
    },
    getImageUrl (data) {
      return {
        url: this.$privateResourcesUrl + data.url,
        name: data.name
      }
    },
    getImageList (arr) {
      this.playUrls = arr.map(e => {
        return this.getImageUrl(e)
      })
    },
    onRemove (file, fileList) {
      for (let i = 0; i < this.currentValue.length; i++) {
        if ((this.$privateResourcesUrl + this.currentValue[i].url) === file.url) {
          this.currentValue.splice(i, 1)
          break
        }
      }
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style>

</style>
